import { render, staticRenderFns } from "./GatewayList.vue?vue&type=template&id=b4046b62&"
import script from "./GatewayList.vue?vue&type=script&lang=js&"
export * from "./GatewayList.vue?vue&type=script&lang=js&"
import style0 from "./GatewayList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports